// ./strip/Payment.tsx
import React, { useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from './Checkout';
import { useDispatch, useSelector } from 'react-redux';
import { createPaymentIntent, selectClientSecret } from '../store/paymentSlice';
import { useLocation } from 'react-router-dom';

const stripePromise = loadStripe("pk_test_0052tKz3FMMtOBVkOBcDvtlA");

const Payment = () => {
  const dispatch = useDispatch<any>();
  const clientSecret = useSelector(selectClientSecret);
  const { state } = useLocation();

  useEffect(() => {
    dispatch(createPaymentIntent(state.programid));
  }, [dispatch]);

    
  const appearance = {
    theme: 'stripe',
  };
  
  const options: any = {  
    clientSecret,
    appearance,
  };

  return (
    <div className="App">
      {clientSecret && (
        <Elements stripe={stripePromise} options={options}>
          <CheckoutForm programId={state.programid} title={state.title} icon={state.icon} cost={state.cost} date={state.date}  clientSecret={clientSecret} />
        </Elements>
      )}
      {!clientSecret && <p>Loading...</p>}
    </div>
  );
};

export default Payment;
